<apm-select
  [placeholder]="'448673' | apmTranslate"
  [clearable]="false"
  [items]="(groups$ | async) || []"
  [useResourceGroupTemplate]="true"
  [ngModel]="selectedGroup()"
  (ngModelChange)="selectedGroup.set($event)"
  bindLabel="name"
  bindValue="id"
  groupBy="groupName"
>
</apm-select>
